var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "scrollContainer", staticClass: "outBox" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.list, function(item, index) {
        return _vm.list.length != 0
          ? _c("div", { key: index, staticClass: "videoBox" }, [
              _c("div", { staticClass: "videoTop" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      height: "24px",
                      width: "218px",
                      "justify-content": "space-between"
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "video-icon",
                      attrs: { src: require("../../assets//video.png") }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "videoTitle" }, [
                      _vm._v(_vm._s(item.knowledgeTitle))
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "down-icon",
                      attrs: { src: require("../../assets/down.png") }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("img", {
                  staticClass: "videoLine",
                  attrs: { src: require("../../assets/line.png") }
                })
              ]),
              _vm._v(" "),
              _c("div", {
                ref: "playerContainer",
                refInFor: true,
                staticClass: "player",
                domProps: {
                  innerHTML: _vm._s(_vm.getSafeIframeHtml(item.videoFileUrl))
                }
              })
            ])
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "loading-tip" }, [_vm._v("加载中......")])
        : _vm._e(),
      _vm._v(" "),
      _vm.noMoreData
        ? _c("div", { staticClass: "no-more-tip" }, [_vm._v("已加载全部视频")])
        : _vm._e(),
      _vm._v(" "),
      _vm.list.length == 0
        ? _c("div", { staticClass: "noVideo" }, [_vm._v("当前无视频教程")])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("iframe", {
        attrs: {
          src:
            "http://player.bilibili.com/player.html?aid=583860403&bvid=BV1iz4y1D7S9&cid=210301283&page=1"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fd55e0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fd55e0e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/webview/videoList.vue
// module id = null
// module chunks = 